/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import createHistory from 'history/createBrowserHistory';

export default createHistory();
